module.exports = __webpack_public_path__ + "img/banner2.2512a05d.png";